import { render, staticRenderFns } from "./Sell.vue?vue&type=template&id=7a84e1d4&scoped=true&"
import script from "./Sell.vue?vue&type=script&lang=ts&"
export * from "./Sell.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a84e1d4",
  null
  
)

export default component.exports